import { render } from "./AdminQuestionnaireDetail.vue?vue&type=template&id=79403b09&scoped=true"
import script from "./AdminQuestionnaireDetail.vue?vue&type=script&lang=js"
export * from "./AdminQuestionnaireDetail.vue?vue&type=script&lang=js"

import "./AdminQuestionnaireDetail.vue?vue&type=style&index=0&id=79403b09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79403b09"]])

export default __exports__